var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-time",
    transform: "translate(0.000000, -2.000000)",
    fill: "#646464",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-timeOnly"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,0 C12.4113769,0 16,3.58862306 16,8 C16,12.4113769 12.4113769,16 8,16 C3.58862306,16 0,12.4113769 0,8 C0,3.58862306 3.58862306,0 8,0 Z M8,1 C4.14001466,1 1,4.14001466 1,8 C1,11.8599853 4.14001466,15 8,15 C11.8599853,15 15,11.8599853 15,8 C15,4.14001466 11.8599853,1 8,1 Z M8,3.16662597 C8.27600097,3.16662597 8.5,3.390625 8.5,3.66662597 L8.5,8.12597656 L11.8533936,11.4793701 C12.0487061,11.6746826 12.0487061,11.991333 11.8533936,12.1866455 C11.7559814,12.284668 11.6280517,12.333374 11.5,12.333374 C11.3719482,12.333374 11.2440186,12.284668 11.1466064,12.1866455 L7.64660644,8.6866455 C7.55261231,8.59265137 7.5,8.46533203 7.5,8.33337403 L7.5,3.66662597 C7.5,3.390625 7.72399903,3.16662597 8,3.16662597 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcClock);
export default __webpack_public_path__ + "static/media/icClock.9ca491e2c8943be25d72be2758c21af8.svg";
export { ForwardRef as ReactComponent };